import React, {Component} from 'react';
import GallCta from "../../GallCta/GallCta";
import billy_joel from "../../../images/billy_joel.png";
import bouncy from "../../../images/bouncy.jpg";
import cheese_judge from "../../../images/cheese_judge.jpg";
import drivers from "../../../images/truck_drivers.jpg";
import veterans from "../../../images/veterans.jpg";
import ziegler from "../../../images/ziegler.jpg";
import eclipse from "../../../images/solar-eclipse.jpg";
import vines from "../../../images/vines.jpg";
import "./Gallery.scss";

/**
 * Gallery
 */
export default class Gallery extends Component {

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        return (
            <div className="gallery layout">

                <section className="gallery__section">
                    <GallCta background={cheese_judge}
                             title={["Judging the U.S. Championship Cheese Content"]}/>
                    <GallCta background={drivers}
                             title={["Truck Drivers Recognition Banquet at the Osthoff"]}/>
                    <GallCta background={billy_joel}
                             title={["Billy Joel Concert Ticket Giveaway"]}/>
                    <GallCta background={veterans}
                             title={["Memorial Day and Veterans Day Tributes"]}/>
                    <GallCta background={bouncy}
                             title={["Biennial Sargento Family Picnic"]}/>
                    <GallCta background={ziegler}
                             title={["Retiree Harold Ziegler visits the Employee Mural in Plymouth"]}/>
                    <GallCta background={eclipse}
                             title={["Sargento Family Members Viewing the Solar Eclipse"]}/>
                    <GallCta background={vines}
                             title={["Vines from the Gentine Ancestors Rescued and Replanted Near Louie’s Office"]}/>
                </section>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Gallery/Gallery.jsx